<component-modal [showClose]="false" [showHeader]="false" class="p-2">
  <ng-container body>
    <div class="d-flex flex-column gap-4">
      <div class="d-flex w-100 flex-column gap-4">
        <div class="d-flex flex-column gap-2 text-center">
          <h4 class="fw-bold mb-0">{{ title() }}</h4>
          <p class="text-center text-muted m-0" [innerHTML]="message()"></p>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container footer>
    <div class="grid-auto-cols flex-grow-1 gap-3">
      @if (choices().length > 0) {
        @for (c of choices(); track c.id) {
          <button
            type="button"
            class="btn"
            [class.btn-sm]="c.buttonSize === 'sm'"
            [class.btn-md]="c.buttonSize === 'md'"
            [class.btn-lg]="c.buttonSize === 'lg'"
            [ngClass]="c.btnClass"
            (click)="onChoice(c.id)">
            {{ c.label }}
          </button>
        }
      } @else {
        <button type="button" class="btn btn-lg btn-light" (click)="onCancel()">
          {{ cancelText() }}
        </button>
        <button type="button" class="btn btn-lg btn-primary" (click)="onConfirm()">
          {{ confirmText() }}
        </button>
      }
    </div>
  </ng-container>
</component-modal>
